'use client';

// Client boundary for the wizard: /create-book's page is a server component (it picks the flow from the flag), and
// CreateBookWizard uses hooks without its own 'use client'. Re-exported unchanged.
export { CreateBookWizard } from './CreateBookWizard';
